<template>
	<div class="header">
		<div class="box center-width">
			<span class="mr40" v-if="!userInfo || !userInfo.userId"><a href="login.html">登录/注册</a></span>
			<span class="mr40" v-else>
				<a href="javascript:;">
					<el-dropdown>
						<span class="el-dropdown-link">
							{{userInfo.partFullName}}<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item><a href="javascript:;" @click="loginOut()">退出登录</a></el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</a>
			</span>
			<span class="mr40" v-if="userInfo && userInfo.userId"><a href="userCenter.html" target="_blank">个人中心</a></span>
			<a href="index.html"><img src="../../assets/images/icons/Telephone_icon.png"/></a>
			<span>客服热线</span>
			<span class="phone mr40">021-31353514</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
		  return {
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || null, // 用户基本信息
      };
		},
		mounted() {
		},
		methods: {
			loginOut() {
				window.localStorage.clear()
				window.location.href = 'login.html'
			}
		},
		components:{
		}
	}
</script>

<style lang="stylus" scoped>
.header {
	width: 100%;
	min-width: 1220px;
	height: 40px;
	text-align: center;
	font-size: 16px;
	background-color: #333333;
	.box, .el-dropdown {
		text-align: right;
		line-height: 40px !important;
		color: #909090 !important;
		font-size: 16px !important;
		img {
			margin-right: 4px;
			margin-top: 11px;
			vertical-align: top;
		}
		.phone {
			font-family: Skia-Regular;
		}
		a:hover {
			color: #409eff;
			text-decoration: none;
		}
	}
}
</style>


// WEBPACK FOOTER //
// header.vue?0f9e8ee2